import { useEffect } from "react";
import logo from "../assets/icons/mba-logo.png";
import userIcon from "../assets/icons/login-user.png";
import "./Navbar.css";

export default function Navbar({
  isLoggedIn,
  onLogin,
  onLogout,
  onHamburgerClick,
  isDarkMode,
  onThemeToggle,
  disableControls = false
}) {
  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      isDarkMode ? "dark" : "light"
    );
  }, [isDarkMode]);

  return (
    <div className="navbar">
      <img src={logo} className="logo-icon" alt="logo" />

      <div className="title">MBA DIGITAL LIBRARY</div>

      <div
        className={`hamburger ${disableControls ? "disabled" : ""}`}
        onClick={onHamburgerClick}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className="nav-right">
        {isLoggedIn && (
          <img src={userIcon} className="nav-icon" alt="user" />
        )}

        <button
          className="button-log"
          onClick={isLoggedIn ? onLogout : onLogin}
        >
          {isLoggedIn ? "Logout" : "Login"}
        </button>

        <button
          className={`button-theme ${disableControls ? "disabled" : ""}`}
          onClick={onThemeToggle}
          disabled={disableControls}
        >
          {isDarkMode ? "☀️ Light" : "🌙 Dark"}
        </button>
      </div>
    </div>
  );
}
